module.exports = __webpack_public_path__ + "media/react/assets/BlankScreenIllustration-90888658eb18cd9128ff237a53a93f90.svg";